import React, { Component } from "react";
import logo from "../../assets/img/logoHeaderInv.svg";
import "./footer.css";

class Footer extends Component {
	render() {
		return (
			<footer>
				<div className={"main-footer"}>
					<div className='container'>
						<div className={"row about"}>
							<div className={"col-12 col-md-6 col-lg-6 logo"}>
								<a href='https://fullmusculo.com/'>
									<img src={logo} alt='logo' />
								</a>
							</div>
							<div className={"col-12 col-md-6 col-lg-6 about-us"}>
								<h5>Acerca de</h5>
								<p>
									FullMúsculo es un espacio informativo, de divulgación y
									educación sobre temas relacionados con la salud, la nutrición
									y el entrenamiento, no debiendo ser utilizado como sustituto
									al diagnóstico médico o tratamiento sin antes consultar a un
									profesional de la salud.
								</p>
							</div>
						</div>
						<div className={"row links"}>
							<ul className={"menu"}>
								<li>
									<a href='/blog'>Blog</a>
								</li>
								<li>
									<a href='/podcast'>Podcast</a>
								</li>
								<li>
									<a href='https://fullmusculo.com/academy'>Academia</a>
								</li>
								<li>
									<a href='https://fullmusculo.com/calculadora-de-calorias'>
										Dietas
									</a>
								</li>
								<li>
									<a href='https://fullmusculo.com/suplementos-deportivos'>
										Suplementos
									</a>
								</li>
								<li>
									<a href='https://fullmusculo.com/ejercicios'>Ejercicios</a>
								</li>
							</ul>
							<div className={"contact"}>
								<p>Contacto: info@fullmusculo.com</p>
								<ul className={"socials"}>
									<li>
										<a
											href={"https://www.facebook.com/LaComunidadFitness/"}
											target={"_blank"}
										>
											<i className={"fab fa-facebook"}></i>
										</a>
									</li>
									<li>
										<a
											href={"http://instagram.com/fullmusculo"}
											target={"_blank"}
										>
											<i className={"fab fa-instagram"}></i>
										</a>
									</li>
									<li>
										<a
											href={"https://www.pinterest.com/Fullmusculo/"}
											target={"_blank"}
										>
											<i className={"fab fa-pinterest"}></i>
										</a>
									</li>
									<li>
										<a
											href={"https://twitter.com/FullMusculo"}
											target={"_blank"}
										>
											<i className={"fab fa-twitter"}></i>
										</a>
									</li>
									<li>
										<a
											href={
												"https://www.youtube.com/channel/UC1Gm7FmLSwvCmmvEfnyl3Tg?sub_confirmation=1"
											}
											target={"_blank"}
										>
											<i className={"fab fa-youtube"}></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div>
							<p
								style={{
									textAlign: "center",
									color: "#cfcfcf",
									marginTop: "30px",
								}}
							>
								David de ponte, Fullmusculo o{" "}
								<a style={{ color: "#cfcfcf" }} href='https://fullmusculo.com/'>
									https://fullmusculo.com/
								</a>{" "}
								no forma parte de Facebook.com o Facebook Inc. Además, David de
								ponte, Fullmusculo y{" "}
								<a style={{ color: "#cfcfcf" }} href='https://fullmusculo.com/'>
									https://fullmusculo.com/
								</a>{" "}
								no cuentan con el respaldo de Facebook, Inc . de cualquier
								manera. Facebook es una marca registrada de Facebook, Inc.
							</p>
						</div>
					</div>
				</div>
				<div className='menu-footer'>
					<div className='container'>
						<span>
							<a href='https://fullmusculo.com/login'>
								© 2023 FullMusculo ™ · Fitness basado en ciencia
							</a>
						</span>
						<ul>
							<li>
								<a href='https://fullmusculo.com/politica-de-privacidad/'>
									Política de privacidad
								</a>
							</li>
							<li>
								<a href='https://fullmusculo.com/terminos-de-uso/'>
									Términos de uso
								</a>
							</li>
							<li>
								<a href='https://fullmusculo.com/about/'>Quienes somos</a>
							</li>
							<li>
								<a href='https://fullmusculo.com/colabora-con-fullmusculo/'>
									Colaborariones
								</a>
							</li>
						</ul>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
